import LinkOrAnchor from "./link-or-anchor";
import NavLinks from "./nav-links";
import pure from "./higher-order/pure";
import React from "react";
import SignupLink from "./signup-link";

export default pure(({ sessionShowLogin }) => {
  var loginLink = (
    <button className="nav_link" onClick={sessionShowLogin} type="button">
      Login
    </button>
  );
  if (window.env.customLoginLinks) {
    loginLink = (
      <LinkOrAnchor className="nav_link" to={window.env.customLoginLinks.login}>
        Login
      </LinkOrAnchor>
    );
  }

  return (
    <nav className="nav">
      <ul className="nav_table">
        <li className="nav_item nav_item--logo">
          <LinkOrAnchor className="nav_logo" to={window.env.homepageUrl} />
        </li>

        <li className="nav_item">
          <NavLinks />
        </li>

        <li className="nav_item nav_item nav_item--login">
          {loginLink}
        </li>

        <li className="nav_item nav_item nav_item--login">
          <SignupLink className="nav_link nav_link--cta">
            Sign Up
          </SignupLink>
        </li>
      </ul>
    </nav>
  );
});
